<template>
    <div
        v-if="isTest"
        class="environment"
    >
        <div class="name">
            {{ envName }}
        </div>
        <p><strong>Адрес:</strong> {{ host }} </p>
        <p><strong>API:</strong> {{ apiHost }} </p>
    </div>
</template>

<script>
import params from '@/config/params';

export default {
    name: 'EnvironmentData',

    data() {
        return {
            params,
        };
    },

    computed: {
        host: () => {
            return window.location.host;
        },

        envName: () => {
            if (params.envName == null) {
                return 'local';
            }

            return params.envName;
        },

        apiHost: () => {
            return (new URL(params.apiDomain)).host;
        },

        isTest: () => {
            return params.env !== 'prod';
        },
    },
};
</script>

<style scoped lang="scss">
    .environment {
        position: fixed;
        bottom: 0;
        background: #ff0000a0;
        text-align: start;
        padding: 10px 20px;
        z-index: 50;
        left: 0;
        p {
            margin-bottom: 2px;
        }
        .name {
            text-align: center;
            font-size: 14pt;
            font-weight: bold;
            padding-bottom: 10px;
            text-transform: uppercase;
        }
    }
</style>